module.exports = __webpack_public_path__ + "media/components/assets/images/tamgeulAllkill/image8-fbcca670bb89f29a740ac5057ee5a771.png";